export default "/assets/images/mila-air-3.webp?4dd9e3001504bb9322a719096e88e6d4";